import React from "react";

function EmptyTodos (){
    return (
        <p>Make ur first todo</p>
    );
}

export { EmptyTodos }

